/** Converte a `extensao` publicada pela Geo-Engine nos limites da câmera. */
export function limitesDaExtensao(extensao) {
    return [
        [extensao.min_x, extensao.min_y],
        [extensao.max_x, extensao.max_y],
    ];
}
function percorrer(coordenadas, visitar) {
    if (!Array.isArray(coordenadas)) {
        return;
    }
    if (typeof coordenadas[0] === 'number') {
        visitar(coordenadas);
        return;
    }
    for (const item of coordenadas) {
        percorrer(item, visitar);
    }
}
/**
 * Calcula os extremos de uma geometria individual recebida da Geo-Engine.
 * Serve exclusivamente para posicionar a câmera do mapa: não é processamento espacial de domínio.
 */
export function calcularLimites(geometria) {
    let oeste = Number.POSITIVE_INFINITY;
    let sul = Number.POSITIVE_INFINITY;
    let leste = Number.NEGATIVE_INFINITY;
    let norte = Number.NEGATIVE_INFINITY;
    const visitar = ([longitude, latitude]) => {
        if (typeof longitude !== 'number' || typeof latitude !== 'number') {
            return;
        }
        oeste = Math.min(oeste, longitude);
        leste = Math.max(leste, longitude);
        sul = Math.min(sul, latitude);
        norte = Math.max(norte, latitude);
    };
    if (geometria.type === 'GeometryCollection') {
        for (const parte of geometria.geometries) {
            percorrer(parte.type === 'GeometryCollection' ? [] : parte.coordinates, visitar);
        }
    }
    else {
        percorrer(geometria.coordinates, visitar);
    }
    if (!Number.isFinite(oeste) || !Number.isFinite(sul)) {
        return null;
    }
    return [
        [oeste, sul],
        [leste, norte],
    ];
}
